<!-- Copyright © 2026 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, including without limitation, material generated from the software programs which are displayed on the screen such as icons, screen display looks, etc. -->

<div
  class="form-group"
  [ngClass]="{
    half: ishalf,
    mfd: isMfd,
    'view-password': viewPassword,
    'mb-0': isMfd && !helpBlock,
    disabled: disabled,
  }">
  @if (label) {
    <label
      for="label"
      [ngClass]="{ 'col-sm-4': ishalf }"
      [xdaTranslate]="label"></label>
  }
  <div class="input-group">
    @if (prependGlyph || prependText || prependButton) {
      <div class="input-group-prepend">
        @if (prependGlyph) {
          <span
            class="input-group-text {{ prependGlyph }}"
            [ngClass]="{ 'input-group-text-readonly': readonly }"></span>
        }
        @if (prependText) {
          <span
            class="input-group-text"
            [ngClass]="{ 'input-group-text-readonly': readonly }"
            >{{ prependText }}</span
          >
        }
        @if (prependButton) {
          <button
            #buttonPrepend
            class="{{ prependButtonConfig.class }}"
            [type]="prependButtonConfig.type"
            id="buttonPrepend"
            [ngbTooltip]="prependButtonConfig.tooltip | xdaTranslate"
            [disableTooltip]="isMfd"
            triggers="{{ isMfd ? '' : prependButtonConfig.tooltipTrigger }}"
            (click)="onPrependButtonAction($any($event))">
            {{ prependButtonConfig.text }}
          </button>
        }
      </div>
    }
    <input
      #input
      ngModel
      keep-placeholder
      [type]="type"
      [id]="id"
      [attr.name]="name"
      [attr.minlength]="minlength"
      [attr.maxlength]="maxlength"
      [min]="minValue"
      [max]="maxValue"
      [placeholder]="placeholder"
      [pattern]="pattern"
      [disabled]="disabled"
      [attr.readonly]="readonly ? 'readonly' : null"
      [autocomplete]="autocomplete"
      (input)="onChange()"
      (blur)="onTouched()"
      (focus)="onFocus()"
      (focusout)="onBlur()"
      (keypress)="onKeyPress($event)"
      (click)="onClick($event)"
      (tap)="onTap($event)"
      [ngClass]="{
        'is-invalid': isErrorState() || onSubmitError,
        'col-sm-8': ishalf,
        'file-name-mfd': isMfd,
        'mfd-input': isMfd,
      }"
      class="form-control" />
    @if (appendGlyph || appendText || appendButton) {
      <div class="input-group-append">
        @if (appendGlyph) {
          <span
            class="input-group-text {{ appendGlyph }}"
            [ngClass]="{ 'input-group-text-readonly': readonly }"></span>
        }
        @if (appendText) {
          <span
            class="input-group-text"
            [ngClass]="{ 'input-group-text-readonly': readonly }"
            >{{ appendText }}</span
          >
        }
        @if (appendButton) {
          <button
            #buttonAppend
            class="{{ appendButtonConfig.class }}"
            [type]="appendButtonConfig.type"
            id="buttonAppend"
            [ngbTooltip]="appendButtonConfig.tooltip | xdaTranslate"
            [disableTooltip]="isMfd"
            triggers="{{ isMfd ? '' : appendButtonConfig.tooltipTrigger }}"
            (click)="onAppendButtonAction($any($event))">
            {{ appendButtonConfig.text }}
          </button>
        }
      </div>
    }
  </div>
  @if ((isMfd || viewPassword) && (type === 'password' || showPassword)) {
    <i
      [ngClass]="showPassword ? 'xgl-view' : 'xgl-view_disabled'"
      (click)="togglePassword()"></i>
  }

  @if ((isErrorState() || onSubmitError) && hasAnyError()) {
    <div
      class="invalid-feedback"
      [ngClass]="{ 'offset-md-4 col-sm-8': ishalf }">
      @if (ngControl.control?.errors?.['required']) {
        <div [xdaTranslate]="'SDE_REQUIRED_FIELD1'"></div>
      }
      @if (ngControl.control?.errors?.['minlength'] && minlengtherror) {
        <div [xdaTranslate]="minlengtherror"></div>
      }
      @if (ngControl.control?.errors?.['maxlength'] && !maxlengtherror) {
        <div>
          <span xdaTranslate>SDE_MAX_LENGTH1</span>&nbsp;<span
            [xdaTranslate]="maxlength.toString()"></span>
        </div>
      }
      @if (ngControl.control?.errors?.['maxlength'] && maxlengtherror) {
        <div>
          <span>{{ maxlengtherror }}</span>
        </div>
      }
      @if (ngControl.control?.errors?.['pattern'] && patternerror) {
        <div [xdaTranslate]="patternerror"></div>
      }
      @if (ngControl.control?.errors?.['email']) {
        <div [xdaTranslate]="'SDE_EMAIL_NOT_VALID'"></div>
      }
      @if (ngControl.control?.errors?.['match']) {
        <div [xdaTranslate]="matcherror"></div>
      }
      @if (ngControl.control?.errors?.['customerror']) {
        <div [xdaTranslate]="error"></div>
      }
    </div>
  }

  @if (noValidateError) {
    <div
      class="novalidate invalid-feedback"
      [ngClass]="{ 'offset-md-4 col-sm-8': ishalf }">
      <div [xdaTranslate]="noValidateError"></div>
    </div>
  }
</div>

@if (helpBlock) {
  <div
    [ngClass]="{
      'row offset-sm-4 help-block col-sm-8': !isMfd && ishalf,
      'text-x-small': isMfd,
    }"
    [xdaTranslate]="helpBlock"></div>
}
